import { Component, HostListener, Input, OnInit, ViewChild, ElementRef } from '@angular/core';
import { NgbActiveModal, NgbDate, NgbModal, NgbModalOptions, NgbTypeahead } from '@ng-bootstrap/ng-bootstrap';
import { Options } from "@angular-slider/ngx-slider";
import { AddCompanyComponent } from 'src/app/components/crm/companies/pop-ups/add-company/add-company.component';
import { AddContactComponent } from 'src/app/components/crm/contacts/pop-ups/add-contact/add-contact.component';
import { TablePaginationModel } from 'src/app/shared/components/ag-grid/ag-grid.model';
import { AgGridService } from 'src/app/shared/components/ag-grid/ag-grid.service';
import { Observable, OperatorFunction, Subject, catchError, debounceTime, distinctUntilChanged, filter, forkJoin, map, merge, of } from 'rxjs';
import { CommonTabService } from 'src/app/shared/services/common-tab.service';
import { WindowSizeService } from '../../../../../shared/services/window-resize.service';
import { ActivityTabService } from '../../../../crm/companies/pages/company-info-tabs/activity-tab/activity-tab.service';
import {RequirementsService} from '../../../requirements/pages/requirements/requirements.service'
import { AddRequirementModel, FulfillmentDetails, OpportunityDetails, QuantityItem, RequirementDetails, RequirementInfo, RequirementParts } from './add-requirement.model';
import { ToastrService } from 'ngx-toastr';
import { SearchService } from 'src/app/shared/services/search.service';
import { CommonDropList } from 'src/app/shared/model/common.model';
import { StingToDateService } from 'src/app/shared/services/stringToDate.service';
import { Button } from 'src/app/shared/model/enum';
import { FilterCheckList } from '../../../../crm/companies/pages/companies/companies.model';
import { DatePipe } from '@angular/common';
import { Categories, LabelsName, PopUpTitles } from '../../../../../shared/model/enum';
import { PartsListService } from '../../../../parts-and-inventory/parts-list/pages/parts-list/parts-list.service';
import { FullFillmentNames } from '../../../../crm/companies/pages/company-info-tabs/settings-tab/settings-tab.model';
import { CommonModelPopUpComponent } from '../../../../../shared/components/common-model-pop-up/common-model-pop-up.component';
import { SendDataService } from '../../../../../shared/services/send-data.service';
import { ModalPopupSize } from '../../../../../shared/model/common.model';
import { AddEditManufacturerComponent } from '../../../../admin/look-up-tables/pop-ups/multi-level-list-popups/add-edit-manufacturer/add-edit-manufacturer.component';
import { AddEditPartComponent } from '../../../../parts-and-inventory/parts-list/popup/add-edit-part/add-edit-part.component';
@Component({
  selector: 'app-add-requirement',
  templateUrl: './add-requirement.component.html',
  styleUrls: ['./add-requirement.component.scss']
})
export class AddRequirementComponent extends SearchService implements OnInit {
  paginationBaseModel              = new TablePaginationModel();
  @Input() headingsNames           : string= '';
  @Input() editName                : string = '';
  @Input() CompnayID               : string;
  @Input() companyInfoName         : string;
  @Input() data                    : any ;
  @Input() isClone: boolean = false;
  @Input() isSelectFromPart: boolean = false;
  disabledContact                  :boolean = true;
  disabledMPNfields                :boolean = false;
  ReqSource                        :any[]= [];
  // currencyList    : CommonDropList[]=[];
  addRequirementInfo               = new AddRequirementModel ();
  requirementInfo                  = new RequirementInfo ();
  requirementDetails               = new RequirementDetails ();
  requirementParts                 = new RequirementParts ();
  fulfillmentDetails               = new FulfillmentDetails ();
  opportunityDetails               = new OpportunityDetails ();
  additionalQuantities: QuantityItem[] = [];
  getRequirementDetailsByMPN       :any;
  companySettingDetails: any;
  startRating                      = 0;
  saleStageList                    :any[] =[{name:'Buy',id:1},{name:'Bid',id:2}];
  projectList                      :any[] =[{name:'Yes',active:true},{name:'No',active:false}];
  active                           = 1;
  options: Options = {
    floor: 0.0,
    ceil: 100.0,
    step: 0.5,
    showSelectionBar: true,
    disabled: false
  };
  // mpnNameList: any[] = []; 
  companyNameList                 = [];
  contactList: any[] = [];
  // dcRestrictionsList              = [];
  // referralSourceList              = [];
  currencyList = [];
  // roHSList                        = [];
  // urgencyList                     = [];
  // oppurtunityTypeList             = [];
  todayDate: Date = new Date();
  submit: boolean = false;
  companyName: string;
  typeId: any[] = [];
  enumButtonName = Button;
  priorityList = [];
  dateCodeWeekList = [];
  dateCodeYearList = [];
  getAllDropdown: any = [];
  filterCheckList = new FilterCheckList();
  enumFilterLabel = LabelsName;
  enumFullFillmentNames = FullFillmentNames;
  isLargeScreen = window.innerWidth > 767.98;
  enumPopUpTitles = PopUpTitles;
  @ViewChild("widgetsContent", { read: ElementRef })
  public widgetsContent!: ElementRef<any>;
  partDetails: any;
  isDraftRequirement: boolean = false;
  highValue: number = 0;
  constructor(
    public modalService: NgbModal,
    public activeModal: NgbActiveModal,
    public agGridService: AgGridService,
    public commonTabService: CommonTabService,
    public activityTabService: ActivityTabService,
    public requirementsService: RequirementsService,
    public toaster: ToastrService,
    private sendDataService: SendDataService,
    public stringToDateService: StingToDateService,
    public datePipe: DatePipe,
    public partsListService: PartsListService,
    private windowSizeService: WindowSizeService,
    public toastr: ToastrService,
  ) { super() }


  ngOnInit(): void {
    this.currencyList = this.commonTabService.getAllDropdownList.getValue().currencyList;
    this.companyNameList = this.commonTabService?.getAllDropdownList?.getValue()?.companyNameList;
    this.highValue = this.opportunityDetails?.closeProbability || 0;
    this.windowSizeService.getScreenWidth().subscribe((res) => {
      this.isLargeScreen = res > 767.98;
    });

    this.allDropdownList();
    this.getRequirementNo();
    if (this.isSelectFromPart) {
      this.requirementDetails.mpnId = this.data?.mpnId;
      this.requirementDetails.mfrId = this.data?.mfrId;
      if (this.requirementDetails.mfrId) {
        this.partDetailsgetById()
      }
    } else {
      if (this.data?.id) {
        this.getRequirementDetailsById(this.data?.id)
      } else {
        this.initializeQuantities()
      }
    }
    if (this.companyInfoName) {
      this.selectValueChange(this.companyInfoName)
    }
  }

  getRequirementDetailsById(id){
    this.requirementsService?.getRequirementDetailsById(id).subscribe({
      next:(res)=>{
        if(res?.isSuccess){
          this.companyInfoName = res.response.requirementInfo.companyName;
          this.selectValueChange(this.companyInfoName);
          this.requirementInfo = res?.response?.requirementInfo;
          this.requirementDetails = res?.response?.requirementDetails;
          this.requirementParts = res?.response?.additionalDetails
          this.opportunityDetails = res?.response?.opportunityDetails
          this.requirementDetails.needDate = this.requirementDetails?.needDate ? this.stringToDateService.convertStringToDate(this.requirementDetails?.needDate) : '';
          if (this.opportunityDetails) {
            this.opportunityDetails.estStartDate = this.opportunityDetails.estStartDate ? this.stringToDateService.convertStringToDate(this.opportunityDetails?.estStartDate) : '';
            this.opportunityDetails.bidDeadline = this.opportunityDetails.bidDeadline ? this.stringToDateService.convertStringToDate(this.opportunityDetails?.bidDeadline) : '';
          }
          this.companyName = res?.response?.requirementInfo?.companyName;
          this.requirementDetails.customerPN = res?.response?.requirementDetails?.cpn;
          this.fulfillmentDetails.id = res?.response?.requirementFulfillment?.id;
          this.fulfillmentDetails.requirementId = res?.response?.requirementDetails?.id;
          this.fulfillmentDetails.companyCOC = res?.response?.requirementFulfillment?.companyCOC;
          this.fulfillmentDetails.manufacturerCOC = res?.response?.requirementFulfillment?.manufacturerCOC;
          this.fulfillmentDetails.requiredImages = res?.response?.requirementFulfillment?.requiredImages;
          this.fulfillmentDetails.requiredInspectionReport = res?.response?.requirementFulfillment?.requiredInspectionReport;
          this.addRequirementInfo.isDraft = res?.response?.isDraft;
          this.isDraftRequirement = res?.response?.requirementInfo?.requirementStatus === 'Draft';
          this.additionalQuantities = res?.response?.additionalQuantities ?? []
          if (this.requirementInfo.companyId) {
          this.getContactListById(this.requirementInfo.companyId).subscribe({
            next: (resp) => {
              if (resp.isSuccess) {
                this.contactList = resp.response?.contactList || [];
                // Show 'No Records Found' as non-clickable option
                if (this.contactList.length === 0) {
                  this.contactList.push({ id: null, name: 'No Records Found', disabled: true });
                }
              }
            }
          });
        }
        if(this.isClone){
          this.getRequirementNo();
        }
        }
      },
      error:(err)=>{}
    })
  }
  initializeQuantities() {
    this.additionalQuantities = [
      {
        requirementDetailId : this.requirementDetails.id ?? '',
        requirementId : this.requirementInfo.id ?? '',
        quantity: 0
      }
    ];
  }
  // getAllMPNDropdownList(){
  //   this.requirementsService.getAllMPNDropdownList().subscribe((res=>{
  //     if(res.isSuccess){
  //       this.mpnNameList = res?.response;
  //     }
  //   }))
  // }
  allDropdownList() {
    this.requirementsService.getAllRequirementDropdown().subscribe((res => {
      if (res.isSuccess) {
        this.getAllDropdown = res?.response;
        // this.dcRestrictionsList = res?.response?.dcRestrictionsList;
        // this.referralSourceList =  res?.response?.referralSourceList;
        // this.roHSList = res?.response?.roHSList;
        // this.urgencyList = res?.response?.urgencyList;
        this.companyNameList = res?.response?.companyNameList
        this.currencyList = res?.response?.currencyList;
      }
    }))
  }
  getRequirementNo() {
    this.requirementsService.getRequirementNo().subscribe((res => {
      if (res.isSuccess) {
        this.requirementInfo.requirementNo = res?.response[0]?.requirementNo;
        this.requirementInfo.requirementDate = res?.response?.requirementDate;
      }
    }))
  }

selectAccountClassId(item, index) {
  this.opportunityDetails.typeId = item.id
}
selecteAccountTypesId(item, index) {
    // Allow only one selected item
  this.typeId = [item];
  this.opportunityDetails.typeId = this.typeId;

  // Update active state
  this.getAllDropdown?.opportunityBuyTypeList?.forEach((x) => {
    x.isActive = x.id === item.id;
  });
  
  // const data = this.typeId.find(a=>a.id == item.id);
  // if(data != null && data != undefined){
  //   const indexToRemove = this.typeId.indexOf(data);
  //   if (indexToRemove !== -1) {
  //     this.typeId.splice(indexToRemove, 1);
  //     this.opportunityDetails.typeId = this.typeId
  //     }
  //   }
  //   else{
  //     this.typeId.push(item);
  //     this.opportunityDetails.typeId = this.typeId;
  //   }
 
  // this.getAllDropdown?.opportunityBuyTypeList?.map((x) => {
  //   const data = this.typeId.find(a=>a.id == x.id);
  //   if(data != null && data != undefined){
  //     x.isActive = true;
  //   }
  //   else{
  //     x.isActive = false;
  //   }
  // })
}

onSelectionChange(saleItem: any) {
    this.opportunityDetails.opportunityTypeId = saleItem.id;
  }
  onSelectionProjectChange(saleItem: any) {
    this.opportunityDetails.isProjectApproved = saleItem.active;
  }
  activeTab(id) {
    this.active = id;
  }
  clearStatusBar(){
     this.startRating = 0;
     this.opportunityDetails.closeProbability = 0;

  }
  openAddEditCompanyModal() {
    const modalOption: NgbModalOptions = {
      centered: true,
      backdrop: "static",
      keyboard: false,
      // size:'xl',
      windowClass: "addCompanyPopUP",
    };
    const modalRef = this.modalService.open(AddCompanyComponent, modalOption);
    modalRef.componentInstance.stagesName = this.paginationBaseModel.stage;
    modalRef.componentInstance.headingsNames = 'Add Company';
    modalRef.result.then((res) => {
      if (res.isSuccess == true) {
        const showCompany = res.response?.response?.generalInfo.companyName;
        this.companyName = showCompany;
        let companyId = res.response?.response?.generalInfo?.id;
        this.requirementInfo.companyId = companyId;
        this.getContactListById(companyId).subscribe(contactsRes => {
          this.contactList = contactsRes.response.contactList;
          this.requirementInfo.contactId = this.contactList[0]?.id;
          this.disabledContact = false;
        });
      }
    })
  }
  openAddContactModal() {
    const modalOption: NgbModalOptions = {
      centered: true,
      backdrop: "static",
      keyboard: false,
      // size:'xl',
      windowClass: "addContactPopup",
    };
    const modalRef = this.modalService.open(AddContactComponent, modalOption);
    modalRef.componentInstance.insertConatactModel.companyId = this.requirementInfo.companyId;
    modalRef.componentInstance.isComapny = true;
    modalRef.componentInstance.disabledCompany = true;
    modalRef.result.then((res) => {
      if (res.isSuccess == true) {
        let companyData =  res?.response?.response?.id
        this.requirementInfo.contactId = companyData
        this.agGridService.setPaginationData(this.paginationBaseModel);
        this.getContactListById(this.requirementInfo.companyId).subscribe({
        next: (resp) => {
            if (resp.isSuccess) {
              this.contactList = resp.response?.contactList || [];
              // Show 'No Records Found' as non-clickable option
              if (this.contactList.length === 0) {
                this.contactList.push({ id: null, name: 'No Records Found', disabled: true });
              }
            }
          }
        });
      }
    });
    // modalRef.componentInstance.stagesName = this.paginationBaseModel.stage;
  }

  selectValueChange(event) {
    this.companyName = event;
    this.disabledContact = !event;
    // Prevent selection of 'No Records Found' option
    if (event === '' || event === 'No Records Found') {
      this.contactList = [];
      this.disabledContact = true;
      this.requirementInfo.companyId = null;
      this.requirementInfo.contactId = null;
    } else {
      this.contactList = [];
      const matchingCompany:any = this.companyNameList?.find(company => company?.name.trim().toLowerCase() === event.trim().toLowerCase());
      this.requirementInfo.companyId = matchingCompany?.id;
      if (matchingCompany) {
        forkJoin({
          contactsRes: this.getContactListById(matchingCompany?.id).pipe( catchError(() => of(null))),
          fulfillmentRes: this.getFullfillmentSettings(matchingCompany?.id).pipe( catchError(() => of(null))),
        }).subscribe({
          next: ({ contactsRes, fulfillmentRes }) => {
            if (contactsRes?.isSuccess) {
              this.contactList = contactsRes?.response?.contactList || [];
              // Show 'No Records Found' as non-clickable option
              if (this.contactList?.length === 0) {
                this.contactList.push({ id: null, name: 'No Records Found', disabled: true });
                setTimeout(() => {
                  this.requirementInfo.contactId = null;
                });
              } else {
                setTimeout(() => {
                  this.requirementInfo.contactId = this.contactList[0].id;
                });
              }
            }
            if (fulfillmentRes?.isSuccess) {
              this.companySettingDetails = fulfillmentRes?.response;
            }
          },
          error: (err) => {
            console.error('API Error:', err);
          }
        });
      }
    }
  }

  companyInputEvent(event) {
    if (event.key === 'Enter') {
      const hasMatchingCompany = this.companyNameList?.some(
        company => company.name.trim().toLowerCase() === this.companyName?.trim().toLowerCase()
      );

      if (!hasMatchingCompany && this.companyName) {
        setTimeout(() =>{
          this.companyUnvavailbleModelOpen();
        },100)
      }
    }
  }
  getContactListById(id) {
   return this.activityTabService.getContactList(id)
  }
  getFullfillmentSettings(id){
    return this.requirementsService.getFullfillmentSettingsByCompanyId(id)
  }
  selectMpnValueChange(event:any, source: 'mpn' | 'mfr'){
      if(event===''){
        this.disabledMPNfields = false; 
        this.requirementDetails =  new RequirementDetails ();
      } 
    if (source === 'mpn') {
      this.requirementDetails.mpnId = event;
      const selectedMpn = this.getAllDropdown?.mpnList?.find((m: any) => m?.id === event);
      if (selectedMpn && selectedMpn.extra1) {
        this.requirementDetails.mfrId = selectedMpn.extra1;
      }
      this.partDetailsgetById();
    } else if (source === 'mfr') {
      this.requirementDetails.mfrId = event;
    }    
    //  else{
    //   //  const matchingMPN = this.mpnNameList?.find(x => x.mpn.trim().toLowerCase() === event.trim().toLowerCase());
    //  // this.getRequirementByMPN(matchingMPN?.mpn);
    //  }

  }

  getRequirementByMPN(MPN: string) {
    if (MPN !== undefined && MPN !== '') {
      this.requirementsService.getRequirementByMPN(MPN).subscribe((res => {
        if (res.isSuccess) {
          this.getRequirementDetailsByMPN = res?.response ?? {};
          //  this.requirementDetails =  new RequirementDetails ();
          // this.requirementDetails.needDate = this.convertStringToDate(this.getRequirementDetailsByMPN.needDate) ?? '';
          this.requirementDetails.requirementId = this.getRequirementDetailsByMPN.id;
          this.requirementDetails.mpnId = this.getRequirementDetailsByMPN.mpn;
          this.requirementDetails.mfrId = this.getRequirementDetailsByMPN.mfr;
          this.requirementDetails.description = this.getRequirementDetailsByMPN.description;
          this.requirementDetails.rohsId = this.getRequirementDetailsByMPN.roHS;
          this.requirementDetails.nsn = this.getRequirementDetailsByMPN.nsn;
          this.requirementDetails.itemPkgId = this.getRequirementDetailsByMPN.itemPackaging;
          this.requirementParts.requirementId = this.getRequirementDetailsByMPN.partsId;
          this.requirementParts.scheduleB = this.getRequirementDetailsByMPN.scheduleB;
          this.requirementParts.eccn = this.getRequirementDetailsByMPN.eccn;
          this.requirementParts.categoryId = this.getRequirementDetailsByMPN.categories;
          this.requirementParts.tempRange = this.getRequirementDetailsByMPN.tempRange;
          this.requirementParts.spq = this.getRequirementDetailsByMPN.spq;
          this.disabledMPNfields = this.requirementDetails ? true : false;
        }
      }))
    }
  }
  clearInputText() {
    const matchingCompany = this.companyNameList?.find(company => company?.name?.trim().toLowerCase() === this.requirementInfo?.companyId?.trim().toLowerCase());

    if (matchingCompany !== undefined) {
      this.companyName = matchingCompany?.name;
      this.requirementInfo.companyId = matchingCompany?.id;
    } else {
      const matchingCompany = this.companyNameList?.find(company => company?.name.trim().toLowerCase() === this.companyName?.trim().toLowerCase());
      if (matchingCompany?.name !== this.companyName) {
        this.companySettingDetails = null
        this.companyName = '';
        this.requirementInfo.companyId = '';
      }
    }
  }
  insertUpdateRequirements(name: string) {
    // preserve UI models (Date objects) — build a payload with converted date strings
    const requirementDate = this.requirementInfo.requirementDate ? this.requirementInfo.requirementDate : this.todayDate.toISOString();
    const needDateStr = this.requirementDetails.needDate ? this.stringToDateService.dateConvertedToString(this.requirementDetails.needDate) : '';
    const estStartDateStr = this.opportunityDetails.estStartDate ? this.stringToDateService.dateConvertedToString(this.opportunityDetails.estStartDate) : '';
    const bidDeadlineStr = this.opportunityDetails.bidDeadline ? this.stringToDateService.dateConvertedToString(this.opportunityDetails.bidDeadline) : '';
    
    // Filter additionalQuantities - remove items with empty/invalid quantities
    const finalAdditionalQuantities = this.additionalQuantities && this.additionalQuantities.length ? this.additionalQuantities.filter(item => item.quantity && item.quantity !== 0 && !isNaN(item.quantity)) : [];
    
    const payload: any = {
      requirementInfo: { ...this.requirementInfo, requirementDate },
      requirementDetails: { ...this.requirementDetails, needDate: needDateStr },
      requirementParts: { ...this.requirementParts },
      opportunityDetails: { ...this.opportunityDetails, estStartDate: estStartDateStr, bidDeadline: bidDeadlineStr },
      requirementFulfillment: { ...this.fulfillmentDetails },
      additionalQuantities: finalAdditionalQuantities,
      isDraft: this.addRequirementInfo.isDraft
    };

    // perform action - validation is already enforced in handleAction
    if (name === 'add') {
      payload.isDraft = false;
      this.insertRequirementData(payload);
    } else if (name === 'update') {
      // use payload for update; do not mutate UI models on error
      this.requirementsService.updateRequirementData(payload).subscribe((res => {
        if (res.isSuccess) {
          this.toaster.success(res.message);
          this.activeModal.close();
          this.requirementsService.recordPass.next(true);
        } else {
          this.toaster.error(res.message)
        }
      }));
    } else if (name === 'draft') {
      payload.isDraft = true;
      this.resetForCloneInsert(payload);
      this.insertRequirementData(payload);
    } else if (name === 'clone') {
      // clones always insert a fresh record
      payload.isDraft = this.addRequirementInfo.isDraft || false;
      this.resetForCloneInsert(payload);
      this.insertRequirementData(payload);
    }
  }
  
  inputValueRohsChange(event: any) {
    if (!this.getAllDropdown?.roHSList) {
      return;
    }
    this.getAllDropdown.roHSList = this.getAllDropdown.roHSList.map(item => {
      if (item.id === event.id) {
        return { ...item, isActive: event.isActive };
      }
      return item;
    });
    let rohsId = this.getAllDropdown?.roHSList?.filter((a) => a?.isActive === true) ?? [];
    this.requirementDetails.rohsId = rohsId;
  }

  inputValueCOOEmit(event: any) {
    if (!this.getAllDropdown?.countryList) {
      return;
    }
    this.getAllDropdown.countryList = this.getAllDropdown.countryList.map(item => {
      if (item.id === event.id) {
        return { ...item, isActive: event.isActive };
      }
      return item;
    });
    let cooId = this.getAllDropdown?.countryList?.filter((a) => a?.isActive === true) ?? [];
    this.requirementDetails.cooId = cooId;
  }


  onChangedValue(event, label) {
    if (event === '') {
      this.clearFields(label, event);
    } else if (event) {
      this.clearFields(label, '');
      this.fetchById(label, event);
    }
  }

  clearFields(label, value) {
    const model = this.requirementParts;
    switch (label) {
      case LabelsName?.CATEGORY_GROUP:
        model.parentCategoryId = model.categoryId = model.subCategoryId = value;
        break;
      case LabelsName?.PARENT_CATEGORY:
        model.categoryId = model.subCategoryId = value;
        break;
      case LabelsName?.CATEGORY:
        model.subCategoryId = value;
        break;
    }
  }

  fetchById(label, event) {
    const ids = {
      [LabelsName?.CATEGORY_GROUP]: Categories?.CATEGORY_GROUPID,
      [LabelsName?.PARENT_CATEGORY]: Categories?.PARENT_CATEGORY_GROUPID,
      [LabelsName?.CATEGORY]: Categories?.CATEGORY_ID,
    };
    this.getById(ids[label], event, label);
  }

  getById(request, id, label) {
    this.partsListService.getInventoryCategoryDropdownById(request, id).subscribe((res) => {
      if (res) {
        switch (label) {
          case LabelsName?.CATEGORY_GROUP:
            this.getAllDropdown.parentCategoryGroupList = res?.response?.list
            break
          case LabelsName?.PARENT_CATEGORY:
            this.getAllDropdown.inventoryCategoryList = res?.response?.list
            break
          case LabelsName?.CATEGORY:
            this.getAllDropdown.subCategoryList = res?.response?.list
            break
        }
      }
    })
  }
  addAdditionalQty() {
    this.additionalQuantities.push({
      requirementDetailId: this.requirementDetails.id ?? '',
      requirementId: this.requirementInfo.id ?? '',
      quantity: 0
    });
  }
 
hasAdditionalQuantity(): boolean {
  return this.additionalQuantities.some((item: any) => item.quantity !== null && item.quantity !== '' && item.quantity !== undefined && item.quantity != 0) ?? false;
}
  deleteQty(index: number) {
    // if (index > 0 && index < this.additionalQuantities.length) {
      this.additionalQuantities.splice(index, 1);
    // }
  }
  updateFullfillmentData(name: string) { }
  checkedInHouse() {
    this.options = {
      ...this.options,
      disabled: this.requirementInfo.isInHouseRequirement
    };
  }
  checkRequiredValue(key: 'draft' | 'insert' = 'insert', isSubmit: boolean = false): boolean {
    let info = this.requirementInfo;
    let details = this.requirementDetails;
    let opportunity = this.opportunityDetails;

    if (key == 'insert') {
      if (!info.isInHouseRequirement) {
        const hasTestingRequirement = this.companySettingDetails?.required3rdPartyTestReport ?? false;
        const hasTestingId = details.testingId;

        if (info.companyId &&
          info.contactId &&
          details.mpnId &&
          details.mfrId &&
          details.qty &&
          details.dateCodeYearId &&
          details.dateCodeWeekId &&
          details.rohsId &&
          details.conditionId &&
          details.needDate &&
          opportunity.opportunityTypeId &&
          (!hasTestingRequirement || hasTestingId)) {
          return true;
        } else {
          if (isSubmit) this.submit = true;
          return false;
        }
      } else {
        if (details.mpnId &&
          details.mfrId &&
          details.qty &&
          details.dateCodeYearId &&
          details.dateCodeWeekId &&
          details.rohsId &&
          details.conditionId) {
          return true;
        } else {
          if (isSubmit) this.submit = true;
          return false;
        }
      }
    } else if (key == 'draft') {
      if (!info.isInHouseRequirement) {

        const hasMinimumFields =
          info.companyId &&
          info.contactId &&
          details.mpnId &&
          details.mfrId &&
          details.qty;

        const hasAnyExtraField =
          details.dateCodeYearId ||
          details.dateCodeWeekId ||
          details.rohsId ||
          details.conditionId ||
          details.needDate

        if (hasMinimumFields && !hasAnyExtraField) {
          return true;
        } else {
          if (isSubmit) this.submit = true;
          return false;
        }

      } else {
        if (isSubmit) this.submit = true;
        return false;
      }
    } else {
      if (isSubmit) this.submit = true;
      return false;
    }
  }

  moveLeft(): void {
    this.widgetsContent.nativeElement.scrollTo({
      left: this.widgetsContent.nativeElement.scrollLeft - 150,
      behavior: "smooth",
    });
  }

  moveRight(): void {
    this.widgetsContent.nativeElement.scrollTo({
      left: this.widgetsContent.nativeElement.scrollLeft + 150,
      behavior: "smooth",
    });
  }
  companyUnvavailbleModelOpen() {
    const modalOption: NgbModalOptions = {
      centered: false,
      backdrop: "static",
      keyboard: false,
      windowClass: 'markAsActiveInactive',
    }
    const modalRef = this.modalService.open(CommonModelPopUpComponent, modalOption);
    modalRef.componentInstance.title = this.enumPopUpTitles.COMPANY_UNAVAILABLE;
    modalRef.componentInstance.fullName = this.companyName;
    modalRef.result.then((result) => {
      if (result.confirm) {
        this.openAddEditCompanyModal()
      }
    })
  }

  openAddEditMFRModal() {
    const data = {}
    this.sendDataService.openModalPopup(AddEditManufacturerComponent, data, 'Add', ModalPopupSize.MD, 'has-parent-popup').then(
      (resultData) => {
        if (resultData?.isSuccess) {
        let selectedMpn = resultData?.response.response?.id;
          this.partsListService.allPartDropdownList().subscribe((res) => {
            this.getAllDropdown = res?.response;
            this.requirementDetails.mfrId = selectedMpn
          });
        }
      }
    );
  }

  openAddPartPopup(title) {
    const data = {}
    this.sendDataService.openModalPopup(AddEditPartComponent, data, title, ModalPopupSize.LG, 'add-part-popup custom-height').then(
      (resultData) => {
        if (resultData.response?.isSuccess) {
          const selectedMpn = resultData.response?.response?.id;
          const selectedMfr = resultData.response?.response?.manufacturerId;
          this.partsListService.allPartDropdownList().subscribe((res) => {
            this.getAllDropdown = res?.response;
            this.requirementDetails.mpnId = selectedMpn;
            this.requirementDetails.mfrId = selectedMfr
          });
        }
      }
    );
  }

  partDetailsgetById() {
    this.requirementParts = new RequirementParts();
    this.partsListService.getPartDetailById(this.requirementDetails.mpnId).subscribe({
      next: (res) => {
        if (res.isSuccess && res.response) {
          this.partDetails = res?.response ?? {};
          this.requirementDetails.mpnId = this.partDetails.id;
          this.requirementParts.categoryGroupId = this.partDetails.complianceExportModel?.categoryGroupId;
          this.requirementParts.parentCategoryId = this.partDetails.complianceExportModel?.parentCategoryId;
          this.requirementParts.categoryId = this.partDetails.complianceExportModel?.categoryId;
          this.requirementParts.subCategoryId = this.partDetails.complianceExportModel?.subCategoryId;
          this.requirementParts.spq = this.partDetails.spq;
          this.requirementParts.moq = this.partDetails.moq;
          this.requirementParts.tempRange = this.partDetails.tempGradeName;
          this.requirementParts.partStatusId = this.partDetails.partStatusId;
        }
      }
    });
  }

  getButtonClass(type: string): string {  
    // disable the draft button when already viewing a draft (unless cloning)
    if (type === 'draft' && this.isDraftRequirement && !this.isClone) {
      return 'button-info popup-button button font-11 ';
    }

    // when editing an existing draft the submit button should always be
    // enabled (we'll decide in handleAction whether the save remains a
    // draft or converts to complete).  This prevents the UI from blocking
    // the user simply because required fields are still empty.
    if (type === 'submit' && this.requirementInfo?.requirementStatus === 'Draft') {
      return 'button-primary popup-button button font-11';
    }
    if (type === 'submit') {
      return 'button-primary popup-button button font-11';
    }

    const isValid = this.checkRequiredValue(type === 'draft' ? 'draft' : 'insert');

    return isValid
      ? 'button-primary popup-button button font-11'
      : 'button-info popup-button button font-11 ';
  }

  handleAction(type: string): void {
    switch (type) {
      case 'draft':
        // if already a draft (and not in the middle of a clone flow) disable
        if (this.isDraftRequirement && !this.isClone) return;

        if (this.requirementInfo?.id) {
          // editing an existing requirement (could be a clone or original)
          if (this.isClone) {
            // when working with a cloned record we still want to enforce
            // the minimum "draft" validation when switching a complete
            // requirement to draft or saving a newly cloned requirement.
            if (!this.checkRequiredValue('draft', true)) return;
            this.addRequirementInfo.isDraft = true;
            this.insertUpdateRequirements('clone');
          } else {
            // normal update – no validation required for draft save
            this.addRequirementInfo.isDraft = true;
            this.insertUpdateRequirements('update');
          }
        } else {
          // creating a brand new requirement (insert or clone)
          if (!this.checkRequiredValue('draft', true)) return;
          this.addRequirementInfo.isDraft = true;
          if (this.isClone) {
            this.insertUpdateRequirements('clone');
          } else {
            this.insertUpdateRequirements('draft');
          }
        }
        break;

      case 'submit':
        // prevent action if button would be disabled
        // submit is only disabled for new/complete requirements that don't pass validation
        if (this.requirementInfo?.requirementStatus !== 'Draft' && !this.checkRequiredValue('insert', true)) {
          return;
        }

        // for existing draft requirements, only allow API call if:
        // (1) all required fields are complete, OR (2) only minimal draft fields are present
        if (this.requirementInfo?.requirementStatus === 'Draft') {
          if (this.checkRequiredValue('insert')) {
            // user has filled all required fields - promote to complete requirement
            this.addRequirementInfo.isDraft = false;
          } else if (this.checkRequiredValue('draft', true)) {
            // user kept minimal draft fields - stay as draft
            this.addRequirementInfo.isDraft = true;
          } else {
            // user added some extra fields but not all required ones - block update
            this.toaster.error('Cannot save due to validation errors.');
            this.submit = true;
            return;
          }

          if (this.isClone) {
            this.insertUpdateRequirements('clone');
          } else if (this.requirementInfo?.id) {
            this.insertUpdateRequirements('update');
          } else {
            this.insertUpdateRequirements('add');
          }
          break;
        }

        // for new and complete requirements, require full insert validation
        if (!this.checkRequiredValue('insert')) {
          this.toaster.error('Cannot save due to validation errors.');
          return;
        }

        this.addRequirementInfo.isDraft = false;

        if (this.isClone) {
          this.insertUpdateRequirements('clone');
        } else if (this.requirementInfo?.id) {
          this.insertUpdateRequirements('update');
        } else {
          this.insertUpdateRequirements('add');
        }
        break;
    }
  }

  private insertRequirementData(payload?: any) {
    this.requirementsService.insertRequirementData(payload).subscribe((res => {
      if (res.isSuccess) {
        this.toaster.success(res.message);
        this.activeModal.close();
        this.requirementsService.recordPass.next(true);
      } else {
        this.toaster.error(res.message)
      }
    }))
  }
    
  private resetForCloneInsert(payload: any) {
    if (payload.requirementInfo) {
      payload.requirementInfo.id = "";
    }

    if (payload.requirementDetails) {
      payload.requirementDetails.id = "";
      payload.requirementDetails.requirementId = "";
    }

    if (payload.requirementParts) {
      payload.requirementParts.id = "";
      payload.requirementParts.requirementId = "";
    }

    if (payload.opportunityDetails) {
      payload.opportunityDetails.id = "";
      payload.opportunityDetails.requirementId = "";
    }

    if (payload.requirementFulfillment) {
      payload.requirementFulfillment.id = "";
      payload.requirementFulfillment.requirementId = "";
    }

    if (payload.additionalQuantities) {
      payload.additionalQuantities = payload.additionalQuantities.map(item => ({
        ...item,
        id: "",
        requirementId: "",
        requirementDetailId: ""
      }));
    }
  }
}
